module.exports = __webpack_public_path__ + "static/img/lj.103d866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lj.png
// module id = 7Yfc
// module chunks = 0